import React from 'react';
import { cn } from 'shared/lib/cn';

export type FigureProps = {
  label: string;
  value: React.ReactNode;
  unit?: string;
  hint?: React.ReactNode;
  loading?: boolean;
  tone?: 'default' | 'brand' | 'flash';
  className?: string;
};

const TONE = { default: 'text-ink', brand: 'text-brand-strong', flash: 'text-flash' } as const;

/** One readout. Figures, not boxes: the value carries the weight, the label is quiet. */
export function Figure({ label, value, unit, hint, loading, tone = 'default', className }: FigureProps) {
  return (
    <div className={cn('flex flex-col gap-0.5', className)}>
      <span className="font-body text-xs text-ink-muted">{label}</span>
      {loading
        ? <span data-testid="figure-skeleton" className="h-5 w-20 animate-pulse rounded-[var(--radius-2)] bg-surface-high" />
        : (
          <span className={cn('font-code text-lg leading-tight', TONE[tone])}>
            {value}
            {unit && <span className="ml-1 font-body text-xs text-ink-muted">{unit}</span>}
          </span>
        )}
      {hint && !loading && <span className="font-body text-xs text-ink-muted">{hint}</span>}
    </div>
  );
}
